import * as React from 'react';
import { IconLogoTock } from '@tock/icons';
import { Typography } from 'bento';
import { internalIdText, internalIdentifier, internalWrapper } from './internalWrapperCssDef';

export type InternalWrapperProps = React.HTMLAttributes<HTMLDivElement>;

/**
 * @deprecated Deprecated — no pantry replacement available yet.
 * Migration: No direct pantry mapping — please reach out to the Design Systems team on Slack (e.g., #pantry-design-system) for assistance with a pantry replacement.
 */
export const InternalWrapper = React.forwardRef<HTMLDivElement, InternalWrapperProps>(
  ({ children, ...rest }, ref) => {
    return (
      <div css={internalWrapper} ref={ref} {...rest}>
        {children}
        <div css={internalIdentifier}>
          <IconLogoTock fontSize="small" />
          <Typography variant="overline" color="contrast" css={internalIdText}>
            employees only
          </Typography>
        </div>
      </div>
    );
  }
);
